module.exports = __webpack_public_path__ + "fonts/onprem_38x38.bbf6c2b92d54ba38cc0af166c8310677.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/onprem_38x38.png
// module id = 746
// module chunks = 9